/**
 * Icon — componente outline SVG reusable (rc56+).
 *
 * Reemplaza imports puntuales de lucide-react. Usa el sprite global
 * (<IconSprite /> en App.tsx) via <use href="#i-..." />.
 *
 * Uso:
 *   <Icon name="dashboard" size={16} className="text-electric" />
 *   <Icon name="bell" />  // 16px por default
 *
 * Stroke 1.6px round/round — identidad visual ByteISP Onyx Electric.
 * `currentColor` heredado del parent: `<a class="text-blue-500"><Icon … /></a>`
 * pinta el icono azul.
 */
import { cn } from "@/lib/utils";

export type IconName =
  // Navegación
  | "dashboard"
  | "users"
  | "file-text"
  | "ticket"
  | "map-pin"
  | "package"
  | "network"
  | "router"
  | "shield"
  | "key"
  | "receipt"
  | "wallet"
  | "phone-call"
  | "alarm-clock"
  | "calendar"
  | "user-cog"
  | "history"
  | "database"
  | "upload"
  | "settings"
  // Topbar
  | "bell"
  | "sun"
  | "moon"
  | "search"
  | "log-out"
  // Acciones
  | "plus"
  | "printer"
  | "ban"
  | "external"
  | "copy"
  | "x"
  | "check"
  | "download"
  | "refresh"
  | "rotate-ccw"
  | "more"
  | "menu"
  | "chevron-left"
  | "chevron-right"
  | "chevron-down"
  | "chevron-up"
  // Status
  | "alert"
  | "info"
  | "clock"
  | "activity"
  | "list"
  | "transfer"
  | "shield-check"
  | "sparkles"
  | "user"
  | "pause"
  | "zap"
  | "x-circle";

type Props = {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  /** Si true, el SVG tiene aria-label = name. Si false, aria-hidden (default). */
  decorative?: boolean;
  title?: string;
};

export function Icon({
  name,
  size = 16,
  strokeWidth = 1.6,
  className,
  decorative = true,
  title,
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("flex-shrink-0", className)}
      aria-hidden={decorative ? "true" : undefined}
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : title || name}
    >
      <use href={`#i-${name}`} />
    </svg>
  );
}
